const filter = () => {
    return (input) => {
        let output = angular.isDefined(input) ? input : "";
        if (output.length > 65) {
            return output.substring(0, 65) + "...";
        }
        else {
            return output;
        }
    };
};
const ɵ0 = filter;
export const ShowBannerMessageFilter = {
    name: 'showBannerMessage',
    filter: filter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-show-banner-message.filter.js.map